import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DriversService } from '../../drivers-service/drivers-service';
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { takeUntil } from "rxjs/operators";
import * as moment from 'moment';
import * as _ from 'underscore';
import { ServiceAreasService } from 'src/app/component/service-areas/service-areas-service/service-areas.service';
import { sweetAlert } from 'src/app/utils/swal';
import { StaffService } from 'src/app/component/staffs/staff-service/staff.service';
import { is } from 'date-fns/locale';

@Component({
  selector: 'app-driver-timelines-v2',
  templateUrl: './driver-timelines-v2.component.html',
  styleUrls: ['./driver-timelines-v2.component.css']
})
export class DriverTimelinesV2Component implements OnInit, OnDestroy {
  duration = 60 * 1000; // 10 seconds
  @ViewChild('timer', { static: true }) timer;
  view = 'list';
  timelineDetails;
  filteredTimeline;
  user;
  timeZone;
  scheduleList = [];
  breakList = [];
  timeoutList = [];
  totalMealBreaks = 0;
  totalRestBreaks = 0;
  search;
  filteredServiceAreas = [];
  selectedServiceArea;
  serviceAreaList: any;
  preServiceAreas = {};
  todayDate;
  breakDetail: boolean = false;
  timeline;
  selectedDriver;
  driversWithoutTimeline = [];
  serviceAreaIds;
  driverByShift = {}
  selectedStationManager = [];
  stationManagerList;
  preStaffList = {};


  constructor(private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private staffService: StaffService

  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.getServiceAreas();
          this.getStationManagers();
          this.getDriverTimelines();
        }
      });
  }

  isBreakDueNow(breakObj) {
    if (breakObj.status === 'open') {
      return false;
    } else if (['rest', 'approved'].includes(breakObj.status)) {
      const stop = moment(breakObj.stop).tz(this.timeZone, false);
      return moment.tz(this.timeZone).isAfter(stop)
        ;
    }
    return true;
  };

  getDriverTimelines() {
    this.serviceAreaIds = [];
    this.filteredServiceAreas = [];
    this.driverService
      .getTimelinesByDate(this.todayDate)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timer.start();
          this.timelineDetails = data.timelines;
          this.timelineDetails.sort((a, b) => ((a.shift && a.shift.checkin) || '').localeCompare((b.shift && b.shift.checkin) || ''));
          this.filteredTimeline = this.timelineDetails;
          this.driversWithoutTimeline = data.driversManifestWithoutTimeline || [];

          this.driversWithoutTimeline.forEach(driver => {
            for (let item of (driver.serviceAreas || [])) {
              this.serviceAreaIds.push(item);
            }

            if (driver.shifts) {

              const now = moment(this.todayDate).tz(this.timeZone);
              this.driverByShift[driver._id] = driver.shifts.find(s => s.isEnabled && s.day ===  now.day());
              if (this.driverByShift[driver._id]) {
                const checkin = moment(this.driverByShift[driver._id].checkin, "HH:mm").tz(this.timeZone);
                driver.shiftStartDiff = checkin.diff(now, 'minutes');
                driver.isCheckinTimePassed = driver.shiftStartDiff < 0 ? true : false;
              }
            }
          });
          this.driversWithoutTimeline.sort((a, b) => a.shiftStartDiff - b.shiftStartDiff);

          // this.driversWithoutTimeline.sort((a, b) => {
          //   return a.shiftStartDiff - b.shiftStartDiff
          // }); // ASC

          if (this.serviceAreaIds && this.serviceAreaIds.length && this.serviceAreaList && this.serviceAreaList.length) {
            this.serviceAreaIds = _.uniq(this.serviceAreaIds);
            if(this.serviceAreaList)
            this.filteredServiceAreas = this.serviceAreaList.filter(s => this.serviceAreaIds.includes(s._id));
          }
          this.filteredData();
        }
      });
  }

  filteredData() {
    this.scheduleList = [];
    this.breakList = [];
    this.timeoutList = [];

    let now = moment().tz(this.timeZone);
    this.totalMealBreaks = 0;
    this.totalRestBreaks = 0;
    this.filteredTimeline.forEach(time => {
      if (time.driver.serviceAreas) {
        for (let item of time.driver.serviceAreas) {
          this.serviceAreaIds.push(item);
        }
      }

      let breakTimeInMillis = 0;
      time.breaks.forEach(b => {
        if (b.status === 'approved') {
          this.totalMealBreaks++;
          breakTimeInMillis += b.duration;
        }
        if (b.status === 'rest') {
          this.totalRestBreaks++;
        }
      });

      if (time.status === 'completed') {
        this.timeoutList.push(time);
      } else {
        // Calculate working hours and break in milliseconds
        let checkIn = moment(time.checkin).tz(this.timeZone, false);
        let milliSeconds = now.diff(checkIn);
        time.workTimeInMillis = milliSeconds - breakTimeInMillis;
        if (time.workTimeInMillis < 0) {
          time.workTimeInMillis = 0;
        }
        time.breakTimeInMillis = breakTimeInMillis;
        // END Calculate working hours and break in milliseconds
        if (time.breaks.length) {
          const latestBreak = time.breaks[time.breaks.length - 1];
          if (!this.isBreakDueNow(latestBreak)) {
            this.breakList.push(time);
          } else {
            this.scheduleList.push(time);
          }
        } else {
          this.scheduleList.push(time);

        }
      }

    });

    if (this.serviceAreaIds && this.serviceAreaIds.length && this.serviceAreaList) {
      this.serviceAreaIds = _.uniq(this.serviceAreaIds);
      this.filteredServiceAreas = this.serviceAreaList.filter(s => this.serviceAreaIds.includes(s._id));
    }


  }

  viewHourFormat(milli) {
    let duration = moment.duration(milli, 'milliseconds');
    return `${Math.floor(duration.asHours())}hr ${duration.minutes()}mins`;
  }

  onTimerComplete(): void {
    this.timer.init();
    this.getDriverTimelines();
  }

  setView(type) {
    this.view = type;
  }

  getTripsCount() {
    let count = 0;
    if (this.scheduleList && this.scheduleList.length) {
      count = count + this.scheduleList.length;
    }

    if (this.breakList && this.breakList.length) {
      count = count + this.breakList.length;
    }

    if (this.timeoutList && this.timeoutList.length) {
      count = count + this.timeoutList.length;
    }

    return count;
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getStationManagers() {
    let queryParams = {
      status: 'active'
    }
    this.staffService
      .getStaffList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.stationManagerList = data.filter(staff => ["mdispatcher", "mcallcenter"].includes(staff.roles));
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  onDateChange(event) {
    this.todayDate = event.toISOString();
    this.getDriverTimelines();
  }

  filterDrivers() {
    this.filteredTimeline = this.timelineDetails.filter(itemOne => {
      let isServiceAreasExist = true;
      let isStationManagerExist = true;
      if (itemOne.driver.serviceAreas && this.selectedServiceArea && this.selectedServiceArea.length) {
        for (let item of this.selectedServiceArea) {
          const isIncluded = itemOne.driver.serviceAreas.includes(item)
          if (isIncluded) {
            isServiceAreasExist = true;
          } else {
            isServiceAreasExist = false;
            break;
          }
        }
      }

      if(itemOne.driver.stationManager && this.selectedStationManager && this.selectedStationManager.length){
        const isIncluded = this.selectedStationManager.includes(itemOne.driver.stationManager)
        if (isIncluded){
          isStationManagerExist = true;
        }else{
          isStationManagerExist = false;
        }

      }
      if (isServiceAreasExist && isStationManagerExist) {
        return true;
      } else {
        return false;
      }
    }
    );

    this.filteredData();
  }

  // breakDetailTimeLine() {
  //   this.breakDetail = true;
  // }

  closeView(){
    this.breakDetail = false;
  }

  viewDetail(currentTimeline) {
    this.driverService
      .getDriverTimelineById(currentTimeline._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeline = data;
          this.breakDetail = true;

          this.selectedDriver = this.timelineDetails.find(d => d.driver._id === this.timeline.driver).driver;
        }
      });
    // this.breakHistory();
  }

  ngOnDestroy(): void {
  }
}
